@if (events.length > 0) {
  <section class="pb-5 text-center">
    <div class="container-lg">
      <h2 class="mb-5 text-muted">Събития и новини</h2>
      <ul class="list-unstyled row row-cols-1 row-cols-sm-2 row-cols-lg-3 row-cols-xl-4 justify-content-center g-4">
        @for (event of events; track event.eventId) {
          <li class="col">
            <div class="w-100 h-100 rounded-3 border shadow overflow-hidden d-flex flex-column bg-light">
              <img [src]="'https://collectoria.bg/assets/events/' + event.imageSource" width="100%" [alt]="event.title">
              <div class="px-3">
                <div class="my-3 fw-bold fs-5">{{ event.title }}</div>
                <div class="my-3">{{ event.shortDescription }}</div>
              </div>
              <button
                type="button"
                class="m-3 mt-auto btn btn-nz-primary"
                (click)="showEventInfo(event)">
                Виж повече
              </button>
            </div>
          </li>
        }
      </ul>
    </div>
  </section>
}
